import React, { forwardRef, ForwardRefRenderFunction, HTMLProps } from 'react';
import FormAddressItem, { FormAddressItemProps } from './FormAddressItem';
import { Loader } from '@dp/product-customizer-components';
import './css/form-address-input.css';

export interface FormAddressInputProps extends HTMLProps<HTMLInputElement> {
  prependItem?: JSX.Element;
  appendItem?: JSX.Element;
  loading?: boolean;
}

const FormAddressInput: ForwardRefRenderFunction<HTMLInputElement, FormAddressInputProps & FormAddressItemProps> = (props, ref): JSX.Element => {
  const cleanPropsForInput = (): HTMLProps<HTMLInputElement> => {
    const cloneProps = { ...props, value: props.value ?? '' };
    delete cloneProps.prependItem;
    delete cloneProps.appendItem;
    delete cloneProps.loading;
    delete cloneProps.errorMessage;
    delete cloneProps.label;
    return cloneProps;
  };

  return (
    <FormAddressItem label={props.label} errorMessage={props.errorMessage}>
      <div className={`fa-input-container ${props.errorMessage && 'error'}`}>
        {props.prependItem && (<div className="fa-input-prepend">{props.prependItem}</div>)}
        <input {...cleanPropsForInput()} ref={ref} type={props.type ?? 'text'} className={`fa-input ${props.className} ${props.errorMessage && 'error'}`} />
        {props.loading && (
          <div className="fa-input-append loader-container"><Loader size={22} /></div>
        ) || props.appendItem && (
        <div className="fa-input-append">{props.appendItem}</div>
      )}
      </div>
    </FormAddressItem>
  );
};

export default forwardRef(FormAddressInput);
